import RequestDetails from "./requestDetails.container";

export default RequestDetails;
